import React from 'react'
import Script from 'next/script'
import useTmsConfig from '@/components/TmsScript/useTmsConfig'

export default function TmsScript({ pathname }: { pathname: string }) {
  const tmsConfig = useTmsConfig(pathname)
  return (
    <Script
      id="pclntms-script"
      strategy="afterInteractive"
      src="/svcs/mkt/tag/pclntms.js"
      onLoad={() => {
        if (window.pclntms) {
          window.pclntms.push(tmsConfig)
        }
      }}
    />
  )
}
